import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { viewStyles as styles } from "@waytek/Overrides/Widgets/ProductDetails/ProductDetailsView";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    gap: 0,
};

styles.leftColumnGridItem = {
    ...styles.leftColumnGridItem,
    css: css`
        ${styles.leftColumnGridItem?.css};

        ${mediaQueriesBP.minMD} {
            padding-right: 30px;
            overflow: visible;
        }
    `,
};

styles.leftColumnInnerContainer = {
    ...styles.leftColumnInnerContainer,
    gap: 0,
};

styles.rightColumnGridItem = {
    ...styles.rightColumnGridItem,
    css: css`
        ${styles.rightColumnGridItem?.css};

        ${mediaQueriesBP.minMD} {
            padding-left: 30px;
        }
    `,
};

styles.smallGridItem = {
    ...styles.smallGridItem,
    width: [12, 12, 0, 0, 0],
};

styles.smallGridItemHidden = {
    ...styles.smallGridItemHidden,
    above: "sm",
    css: css`
        width: 100%;
        direction: ltr;
    `,
};

styles.largeGridItem = {
    ...styles.largeGridItem,
    width: 12,
};

const numbersSizeCss = css`
    ${mediaQueriesBP.maxMD} {
        width: 100%;
    }

    ${mediaQueriesBP.minMD} {
        width: calc(50% - 10px);
    }
`;
styles.numbersWrapper = {
    ...styles.numbersWrapper,
    css: css`
        width: 100%;

        & > div {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: flex-start;

            & > div[data-widget] {
                ${numbersSizeCss}
            }
            & > ${TypographyStyle} {
                ${numbersSizeCss}
            }
        }
    `,
};

styles.imageWrapper = {
    ...styles.imageWrapper,
    css: css`
        ${styles.imageWrapper?.css}
        position: relative;
        width: 100%;
        margin: 22px 0 20px;

        ${mediaQueriesBP.maxMD} {
            padding: 2px;
        }

        ${mediaQueriesBP.minMD} {
            height: 320px;
            padding: 10px 15px;
            border: 1px solid ${getColor(colorStrings.commonGlobalLightGray)};
            display: inline-flex;
            align-items: center;
        }

        .productDetailsPrimaryImage {
            ${mediaQueriesBP.maxMD} {
                border: 1px solid ${getColor(colorStrings.commonGlobalLightGray)};
                padding: 5px;
            }

            ${mediaQueriesBP.minMD} {
                width: calc(100% - 95px);
            }
        }

        .productDetailsImageCarousel {
            ${mediaQueriesBP.maxMD} {
                margin-top: 15px;
            }

            ${mediaQueriesBP.minMD} {
                position: absolute;
                top: 10px;
                right: 15px;
                width: 60px;
                bottom: 10px;
            }
        }
    `,
};

styles.labelStyle = {
    ...styles.labelStyle,
    css: css`
        ${mediaQueriesBP.maxMD} {
            order: 4;
        }
        ${mediaQueriesBP.minMD} {
            order: 3;
        }
    `,
};

styles.attributesStyle = {
    ...styles.attributesStyle,
    css: css`
        ${mediaQueriesBP.maxMD} {
            order: 3;
        }
        ${mediaQueriesBP.minMD} {
            order: 4;
        }
    `,
};

styles.pricingBox = {
    css: css`
        border: 1px solid ${getColor(colorStrings.commonGlobalIndustrialTaupe)};
        background-color: ${getColor(colorStrings.commonGlobalFadedTaupe)};

        ${mediaQueriesBP.maxMD} {
            margin: 0 0 15px;
            padding: 14px 15px 15px;
        }

        ${mediaQueriesBP.minMD} {
            margin: 22px 0 20px;
            padding: 35px 26px 25px;
        }
    `,
};

styles.siteMessageWrapper = {
    css: css`
        ${styles.siteMessageWrapper?.css}
        margin-top: -9px;
    `,
};

styles.siteMessage = {
    size: "14px",
    lineHeight: "24px",
    weight: 600,
};

styles.siteMessageLink = {
    ...styles.siteMessageLink,
    typographyProps: {
        size: "14px",
        lineHeight: "24px",
        weight: 500,
    },
};
